<template>
    <div>
        <table class="min-w-full divide-y divide-gray-200 relative">
            <thead class="sticky top-0 bg-gray-50 z-10">
                <tr>
                    <th scope="col" rowspan="2" colspan="2" class="sticky-top-0 left-0 z-10 bg-gray-50 px-1 py-2">
                        &nbsp;
                    </th>
                    <th
                        scope="col"
                        class="sticky-top-0 bg-gray-50 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        v-if="false"
                    >
                        &nbsp;
                    </th>
                    <th
                        scope="col"
                        v-for="(tag, index) in table.tags"
                        :colspan="table.meta.tag_colspan"
                        :key="tag.id"
                        :class="{ 'bg-gray-200': index % 2 === 0, 'bg-gray-50': index % 2 !== 0 }"
                        class="sticky-top-0 px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r-4 border-gray-500"
                    >
                        {{ tag.name }}
                    </th>
                </tr>
                <tr>
                    <th scope="col" rowspan="2" class="sticky-top-0 left-0 z-10 bg-gray-50 px-1 py-2" v-if="false">
                        &nbsp;
                    </th>
                    <template v-for="tag in table.tags" :key="tag.id">
                        <th
                            v-for="(mode, modeIndex) in table.modes"
                            :key="mode.id"
                            scope="col"
                            :colspan="table.meta.mode_colspan"
                            :class="{
                                'bg-gray-50': modeIndex % 2 === 0,
                                'bg-gray-200': modeIndex % 2 !== 0,
                                'border-r-4 border-gray-500': modeIndex === table.modes.length - 1,
                            }"
                            class="sticky-top-0 px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ mode.text }}
                        </th>
                    </template>
                </tr>
                <tr>
                    <th scope="col" class="sticky-top-0 left-0 z-10 bg-gray-50 px-1 py-2">
                        <span class="sr-only">{{ $t('messages.avatar') }}</span>
                    </th>
                    <th
                        scope="col"
                        class="sticky-top-0 bg-gray-50 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {{ $t('messages.name') }}
                    </th>
                    <template v-for="tag in table.tags" :key="tag.id">
                        <template v-for="(mode, modeIndex) in table.modes" :key="mode.id">
                            <th
                                scope="col"
                                class="sticky-top-0 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.attempts_reached') }}
                            </th>
                            <th
                                scope="col"
                                class="sticky-top-0 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $tc('messages.attempts', 2) }}
                            </th>
                            <th
                                scope="col"
                                class="sticky-top-0 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.efficiency') }}
                            </th>
                            <th
                                scope="col"
                                class="sticky-top-0 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.level_reached_short') }}
                            </th>
                            <th
                                scope="col"
                                class="sticky-top-0 px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                :class="{
                                    'border-r-4 border-gray-500': modeIndex === table.modes.length - 1,
                                }"
                            >
                                {{ $t('messages.expected_level_short') }}
                            </th>
                        </template>
                    </template>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
                <tr class="even:bg-gray-50" v-for="student in table.students">
                    <td class="sticky left-0 px-2 py-1 whitespace-nowrap sticky left-0 bg-gray-50">
                        <div class="flex items-center">
                            <div class="shrink-0 h-6 w-6">
                                <img
                                    :alt="student.full_name"
                                    :title="student.full_name"
                                    class="h-6 w-6 rounded-full"
                                    :src="student.avatar_or_default"
                                />
                            </div>
                        </div>
                    </td>
                    <td class="px-2 py-1 whitespace-nowrap text-sm text-gray-500 border-r">
                        <InertiaLink :href="student.links.show" class="text-indigo-500">
                            {{ student.full_name }}
                        </InertiaLink>
                    </td>
                    <template v-for="studentTag in student.tags">
                        <template v-for="(mode, modeIndex) in table.modes" :key="mode.id">
                            <td class="px-2 py-1 text-center whitespace-nowrap text-sm text-gray-700 border-r">
                                <span v-if="studentTag.reached_count[mode.id] === null" class="text-gray-400"> - </span>
                                <template v-else>
                                    {{ studentTag.reached_count[mode.id] }}
                                </template>
                            </td>
                            <td class="px-2 py-1 text-center whitespace-nowrap text-sm text-gray-700 border-r">
                                <span v-if="studentTag.count[mode.id] === null" class="text-gray-400"> - </span>
                                <template v-else>
                                    {{ studentTag.count[mode.id] }}
                                </template>
                            </td>
                            <td class="px-2 py-1 text-center whitespace-nowrap text-sm text-gray-700 border-r">
                                <span v-if="studentTag.efficiency[mode.id] === null" class="text-gray-400"> - </span>
                                <template v-else> {{ studentTag.efficiency[mode.id] }}% </template>
                            </td>
                            <td class="px-2 py-1 text-center whitespace-nowrap text-sm text-gray-700 border-r">
                                <span v-if="studentTag.level[mode.id] === null" class="text-gray-400"> - </span>
                                <template v-else>
                                    {{ studentTag.level[mode.id] }}
                                </template>
                            </td>
                            <td
                                class="px-2 py-1 text-center whitespace-nowrap text-sm text-gray-700 border-r-4"
                                :class="{
                                    'border-r-4 border-gray-500': modeIndex === table.modes.length - 1,
                                }"
                            >
                                {{ studentTag.expected_level }}
                            </td>
                        </template>
                    </template>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { IconLifebuoy } from '@tabler/icons-vue';
import { Tippy } from 'vue-tippy';

export default {
    name: 'TagLevelReachedGroupTable',
    props: ['table'],
    components: {
        Tippy,
        IconLifebuoy,
    },
};
</script>
